import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { HttpUtil } from 'src/service/common.http';
import { HandleError, HttpErrorHandler } from 'src/service/http-error-handler.service';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor(private http: HttpUtil, private httpErrorHandler: HttpErrorHandler) {
    this.handleError = httpErrorHandler.createHandleError('StoreService')
  }

  private handleError: HandleError
  private urlConfig = {
    report: ' /a/7moor/cusAchievement/search',
    customer: '/a/7moor/customerService/search'
  }

  getReport(params): Promise<any> {
    params.merchantId = localStorage.getItem('merchantId') || ''
    params.token = localStorage.getItem('token') || ''
    return this.http
      .get(this.urlConfig.report, { params })
      .pipe(catchError(this.handleError('getReport')))
      .toPromise()
      .then((res: any) => (res.code === 0 ? res : Promise.reject(res)))
  }
  getCustomer(params): Promise<any> {
    params.merchantId = localStorage.getItem('merchantId') || ''
    params.token = localStorage.getItem('token') || ''
    return this.http
      .get(this.urlConfig.customer, { params })
      .pipe(catchError(this.handleError('getCustomer')))
      .toPromise()
      .then((res: any) => (res.code === 0 ? res : Promise.reject(res)))
  }

}
